import { render, staticRenderFns } from "./ContainerComponent.vue?vue&type=template&id=74648664&scoped=true"
import script from "./ContainerComponent.vue?vue&type=script&lang=js"
export * from "./ContainerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74648664",
  null
  
)

export default component.exports